import { callWhenIdle } from '@atlassian/jira-call-when-idle';
import { initControlsOnce } from '@atlassian/jira-browser-storage-controls/src/utils/init-once/index.tsx';
import {
	type CookieCircuitBreakerConfig,
	CookieCircuitBreaker,
} from './cookie-circuit-breaker.tsx';
import { didSSRSucceed } from './did-ssr-succeed.tsx';
import { getCookieCircuitBreakerKillswitch } from './killswitch.tsx';

export function setCircuitBreakerOnIdle({
	isSetCookieEnabled,
	cookieKey,
	windowSize,
	threshold,
	keepOpenCount,
	halfOpenForCount,
}: CookieCircuitBreakerConfig & {
	isSetCookieEnabled: boolean;
}) {
	if (isSetCookieEnabled) {
		callWhenIdle(async () => {
			await initControlsOnce();
			const circuitBreaker = new CookieCircuitBreaker({
				cookieKey,
				windowSize,
				threshold,
				keepOpenCount,
				halfOpenForCount,
				version: getCookieCircuitBreakerKillswitch() ?? 0,
			});
			const didVersionMismatch = circuitBreaker.resetCookieIfVersionMismatch();
			// Do not record a pass/fail if we just reset the cookie incase it failed due
			// to the circuit breaker being OPEN
			if (!didVersionMismatch) {
				if (didSSRSucceed()) {
					circuitBreaker.recordPass();
				} else {
					circuitBreaker.recordFailure();
				}
			}
		}, 1000);
	}
}
